
export default function ServicesText() {
  return (
    <>
    <section className="texteffect">
        <div className="scroll-reveal">
            <p><span style={{ animationTimeline: 'view(y)',}}>Every project is a new opportunity to innovate, craft, and deliver interiors that are both iconic and timeless and resonate with our clients’ personality and lifestyle.</span></p>
        </div>
      
          <div class="image-wrapper" style={{ animationTimeline: 'view()', animationRange: 'cover contain' }}>
            <img src="/image/service-effect.webp" loading="lazy" alt="service"/>
        </div>
    </section>
    </>
  )
}
